export const environment = {
  production: true,
  project:'ADR',
  component: 'FLIGHTTURNAROUND',
  area: 'Qa',
  customer: 'Qa',
  product: 'Qa',
  location: 'Qa',
  host: "https://qaapi.adr.avileap.com/api/AviLeap",
  socketHost: "https://qaapi.adr.avileap.com",
  analyticsHost: "https://qaapi.adr.avileap.com/api/analytics",
  analytics: "https://qaapi.adr.avileap.com/auth",
  base: "https://qaapi.adr.avileap.com",
  baseWithAPI: "https://qaapi.adr.avileap.com/api",
  publichost: "https://qaapi.adr.avileap.com/api/public",
  socketconnection: "/socket",
  publickey: 'BOp8piyvQFTSO4IN7OOcTk4zwnTd0wkh-eVabYX88V_Je-tohftyep-CkSLkIR0nrhPLsCvCP4Hr_dgwyATc53I',
  privatekey: 'tOtT9wdiuN7DPiD1fMquKty03_S_gjdsHkjvPpTQwVA',
  gmtvalue:'Europe/Rome'
};